var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("基本信息")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "欢迎语内容",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["content", _vm.rules.content],
                            expression: "['content',rules.content]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "是否启用",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-switch", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["isUse", { valuePropName: "checked" }],
                            expression:
                              "['isUse',{ valuePropName: 'checked' }]",
                          },
                        ],
                        attrs: {
                          "checked-children": "是",
                          "un-checked-children": "否",
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#ff0000",
                            "line-height": "30px",
                          },
                        },
                        [_vm._v("（如设置启用会自动关闭其他已启用欢迎语）")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [
            _vm._v("添加照片/视频/文件/网页/小程序"),
          ]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "div",
                    {
                      staticStyle: { color: "#ff0000", "line-height": "30px" },
                    },
                    [
                      _vm._v(
                        "（仅可选择一类消息类型，若切换则已填写内容会被清空）"
                      ),
                    ]
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "消息类型",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { "button-style": "solid" },
                          model: {
                            value: _vm.msgType,
                            callback: function ($$v) {
                              _vm.msgType = $$v
                            },
                            expression: "msgType",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "image" } }, [
                            _vm._v("图片"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "video" } }, [
                            _vm._v("视频"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "file" } }, [
                            _vm._v("文件"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "link" } }, [
                            _vm._v("图文链接"),
                          ]),
                          _c(
                            "a-radio-button",
                            { attrs: { value: "miniprogram" } },
                            [_vm._v("小程序")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _vm.msgType === "image"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "图片设置",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["imageUrls"],
                              expression: "['imageUrls']",
                            },
                          ],
                          attrs: {
                            num: 9,
                            accept: "image/*",
                            url: _vm.api.temp.WX_UPLOAD_PATH + "?uploadType=2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：png,jpg,gif，建议大小2M，最多9张")]
                    ),
                  ]
                : _vm._e(),
              _vm.msgType === "video"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "视频设置",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["videoUrls"],
                              expression: "['videoUrls']",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept: "video/*",
                            url: _vm.api.temp.WX_UPLOAD_PATH + "?uploadType=2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：mp4，建议大小2M，最多1个")]
                    ),
                  ]
                : _vm._e(),
              _vm.msgType === "file"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "文件设置",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["fileUrls"],
                              expression: "['fileUrls']",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept: "*",
                            url: _vm.api.temp.WX_UPLOAD_PATH + "?uploadType=2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议大小2M，最多1个")]
                    ),
                  ]
                : _vm._e(),
              _vm.msgType === "miniprogram"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序标题",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "miniprogramTitle",
                                _vm.rules.miniprogramTitle,
                              ],
                              expression:
                                "['miniprogramTitle',rules.miniprogramTitle]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序appid",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "miniprogramAppid",
                                _vm.rules.miniprogramAppid,
                              ],
                              expression:
                                "['miniprogramAppid',rules.miniprogramAppid]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序页面地址",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "miniprogramPage",
                                _vm.rules.miniprogramPage,
                              ],
                              expression:
                                "['miniprogramPage',rules.miniprogramPage]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序封面图",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["miniprogramImgUrl"],
                              expression: "['miniprogramImgUrl']",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept: "image/*",
                            url: _vm.api.temp.WX_UPLOAD_PATH + "?uploadType=2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：png,jpg，封面图建议尺寸为520*416")]
                    ),
                  ]
                : _vm._e(),
              _vm.msgType === "link"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "网页标题",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["linkTitle", _vm.rules.linkTitle],
                              expression: "['linkTitle',rules.linkTitle]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "网页链接",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["linkUrl", _vm.rules.linkUrl],
                              expression: "['linkUrl',rules.linkUrl]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "网页封面图",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["linkImgUrl"],
                              expression: "['linkImgUrl']",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept: "image/*",
                            url: _vm.api.temp.WX_UPLOAD_IMG_PATH,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：png,jpg，建议大小2M")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }